import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle
} from '@/components-latest/primitives/Dialog'
import Text from '@/components-latest/primitives/Text'

import Styles from './AutoAcceptConfirmationModal.module.scss'

interface AutoAcceptConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isEnabling: boolean
  isLoading?: boolean
}

const AutoAcceptConfirmationModal: React.FC<AutoAcceptConfirmationModalProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isEnabling,
  isLoading = false
}) => {
  const { t } = useTranslation()

  const title = isEnabling
    ? t('account.order-preferences.auto-accept.enable-modal.title')
    : t('account.order-preferences.auto-accept.disable-modal.title')

  const description = isEnabling
    ? t('account.order-preferences.auto-accept.enable-modal.description')
    : t('account.order-preferences.auto-accept.disable-modal.description')

  const confirmText = isEnabling
    ? t('account.order-preferences.auto-accept.enable-modal.confirm')
    : t('account.order-preferences.auto-accept.disable-modal.confirm')

  const closeModal = () => onOpenChange(false)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={Styles.modalContent}>
        <DialogClose className={Styles.close} />
        <div className={Styles.inner}>
          <div className={Styles.textBlock}>
            <Text variant="heading-04" weight="semiBold" asChild>
              <DialogTitle className={Styles.title}>{title}</DialogTitle>
            </Text>
            <Text variant="subtitle" asChild>
              <DialogDescription className={Styles.description}>
                {description}
              </DialogDescription>
            </Text>
          </div>
          <div className={Styles.footer}>
            <Button
              size="small"
              shape="rounded"
              variant="tertiary"
              className={Styles.actionButton}
              type="button"
              disabled={isLoading}
              onClick={closeModal}>
              {t('common.modal.cancel')}
            </Button>
            <Button
              size="small"
              shape="rounded"
              variant="branded"
              className={Styles.actionButton}
              type="button"
              loading={isLoading}
              onClick={onConfirm}>
              {confirmText}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AutoAcceptConfirmationModal
